var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerifiedUser = function SvgVerifiedUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.9 15.325 5.7-5.7L15.55 8.6l-4.575 4.575L8.45 10.65l-1.1 1.1zm1.1 6.65q-3.5-.875-5.75-4.063Q4 14.726 4 10.926v-5.95l8-3 8 3v5.95q0 3.8-2.25 6.988T12 21.976zm0-1.55q2.876-.95 4.688-3.588t1.812-5.912v-4.9L12 3.575l-6.5 2.45v4.9q0 3.275 1.813 5.912Q9.125 19.476 12 20.425"
  })));
};
export default SvgVerifiedUser;